/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, theme } from "@nordcloud/gnui";
import { useAuth0 } from "~/services/auth";
import { AvatarIcon } from "../HeaderIcons";
import { DropdownWrap } from "./DropdownWrap";
import { UserImage, UserName } from "./styles";

export function User() {
  const { user } = useAuth0();
  const userName = user?.name ?? "";

  return (
    <>
      <DropdownWrap userName={userName}>
        <FlexContainer columnGap={theme.spacing.spacing03}>
          {user?.picture ? <UserImage src={user?.picture} alt={userName} /> : <AvatarIcon />}
          <FlexContainer mr={theme.spacing.spacing02}>
            <UserName>{userName}</UserName>
          </FlexContainer>
        </FlexContainer>
      </DropdownWrap>
    </>
  );
}
